import anime from "animejs";
import tippy from "tippy.js";
import CountUp from "countup.js";

import { $, $1, each } from "../util";

const AnimationManager = (() => {
  const initHomeActiveAnim = () => {
    const homeCategories = $(".c-home__main-category");

    // each(homeCategories, (i, homeCategory) => {
    //   homeCategory.addEventListener('click', function() {
    //     each(homeCategories, (l, hc) => {
    //       hc.classList.remove('is-active')
    //     })
    //     this.classList.add('is-active')
    //   })
    // })
  };

  const enterTransition = (cb) => {
    const changePage = $1(".js-page-transition");
    const enterTl = anime.timeline();

    changePage.style.zIndex = "1000000";

    setTimeout(() => {
      document.body.classList.remove("is-mobile-open");
      document.body.classList.remove("is-sub-mobile-open");
    }, 300);

    enterTl.add({
      targets: changePage,
      translateX: "100%",
      duration: 500,
      easing: [0.694, 0.048, 0.335, 1.0],
      complete: () => {
        cb.call();
      },
    });
  };

  const exitTransition = () => {
    const changePage = $1(".js-page-transition");
    const exitTl = anime.timeline();

    exitTl.add({
      targets: changePage,
      translateX: "200%",
      duration: 500,
      easing: [0.694, 0.048, 0.335, 1.0],
      complete: () => {
        anime({
          targets: changePage,
          zIndex: "-1",
          translateX: "0%",
          duration: 0,
        });

        setTimeout(() => {
          revealPage();
        }, 500);
      },
    });
  };

  const hideNav = () => {
    const navLogo = $1(".c-nav__logo");
    const navLinks = $1(".c-nav__links");
    const socialFixed = $1(".o-social-fix");

    anime({
      targets: navLinks,
      translateY: "30px",
      opacity: "0",
      duration: 0,
    });

    anime({
      targets: socialFixed,
      translateY: "30px",
      opacity: "0",
      duration: 0,
    });

    anime({
      targets: navLogo,
      opacity: "0",
      duration: 0,
    });
  };

  const revealNav = () => {
    const navLogo = $1(".c-nav__logo");
    const navLinks = $1(".c-nav__links");
    const socialFixed = $1(".o-social-fix");

    const navTl = anime.timeline();

    navTl
      .add({
        targets: navLogo,
        opacity: {
          value: 1,
          easing: "linear",
        },
        duration: 500,
        offset: "-=200",
      })
      .add({
        targets: navLinks,
        opacity: {
          value: 1,
          easing: "linear",
        },
        translateY: {
          value: "0%",
          easing: [0.694, 0.048, 0.335, 1.0],
        },
        duration: 500,
        offset: "-=300",
      })
      .add({
        targets: socialFixed,
        opacity: {
          value: 1,
          easing: "linear",
        },
        translateY: {
          value: "0%",
          easing: [0.694, 0.048, 0.335, 1.0],
        },
        duration: 500,
        offset: "-=400",
      });
  };

  const hideHome = () => {
    const home = document.getElementById("home");

    if (home) {
      const heroVideo = home.querySelector(".c-hero__video-bg");
      const heroShapeLeft = home.querySelector(".c-hero__shape--left");
      const heroShapeRight = home.querySelector(".c-hero__shape--right");
      const heroClaim = home.querySelector(".c-hero__claim");
      const heroTitle = home.querySelector(".c-hero__title");
      const heroSubtitle = home.querySelector(".c-hero__subtitle");
      const heroScrollDown = home.querySelector(".c-hero__scroll-down path");

      anime({
        targets: heroVideo,
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: heroShapeLeft,
        translateX: "-50%",
        duration: 0,
        skewX: "-20deg",
      });

      anime({
        targets: heroShapeRight,
        translateX: "50%",
        duration: 0,
        skewX: "-20deg",
      });

      anime({
        targets: heroClaim,
        translateY: "-50px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: heroTitle,
        translateY: "-20px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: heroSubtitle,
        translateY: "-20px",
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });
    }
  };

  const revealHome = () => {
    const home = document.getElementById("home");

    if (home) {
      const heroVideo = home.querySelectorAll(".c-hero__video-bg");
      const heroShapeLeft = home.querySelector(".c-hero__shape--left");
      const heroShapeRight = home.querySelector(".c-hero__shape--right");
      const heroClaim = home.querySelector(".c-hero__claim");
      const heroTitle = home.querySelector(".c-hero__title");
      const heroSubtitle = home.querySelector(".c-hero__subtitle");
      const heroScrollDown = home.querySelector(".c-hero__scroll-down path");

      const homeTl = anime.timeline();

      homeTl
        .add({
          targets: heroVideo,
          opacity: 1,
          easing: "linear",
          duration: 700,
        })
        .add({
          targets: heroShapeLeft,
          translateX: "0%",
          duration: 500,
          skewX: "-20deg",
          easing: [0.694, 0.048, 0.335, 1.0],
          offset: "-=400",
        })
        .add({
          targets: heroShapeRight,
          translateX: "0%",
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 500,
          skewX: "-20deg",
          offset: "-=100",
        })
        .add({
          targets: heroClaim,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          offset: "-=200",
          duration: 500,
        })
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroSubtitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
          complete: () => {
            revealNav();
            let firstNumAnim;
            let secondNumAnim;
            let thirdNumAnim;
            let fourthNumAnim;
            let lastNumAnim;

            const home = document.getElementById("home");
            if (home) {
              const options = {
                separator: "'",
              };
              const firstNumber = home.querySelector(".js-home-first-number");
              const secondNumber = home.querySelector(".js-home-second-number");
              const thirdNumber = home.querySelector(".js-home-third-number");
              const fourthNumber = home.querySelector(".js-home-fourth-number");
              const lastNumber = home.querySelector(".js-home-last-number");

              const firstEndValue = firstNumber.dataset.end;
              firstNumAnim = new CountUp(
                firstNumber,
                0,
                firstEndValue,
                0,
                1.5,
                options
              );
              const secondEndValue = secondNumber.dataset.end;
              secondNumAnim = new CountUp(
                secondNumber,
                0,
                secondEndValue,
                0,
                1.5,
                options
              );
              const thirdEndValue = thirdNumber.dataset.end;
              thirdNumAnim = new CountUp(
                thirdNumber,
                0,
                thirdEndValue,
                0,
                1.5,
                options
              );
              const fourthEndValue = fourthNumber.dataset.end;
              fourthNumAnim = new CountUp(
                fourthNumber,
                0,
                fourthEndValue,
                0,
                1.5,
                options
              );
              const lastEndValue = lastNumber.dataset.end;
              lastNumAnim = new CountUp(
                lastNumber,
                0,
                lastEndValue,
                0,
                1.5,
                options
              );
              if (!firstNumAnim.error) {
                firstNumAnim.start(() => {});
                secondNumAnim.start(() => {});
                thirdNumAnim.start(() => {});
                fourthNumAnim.start(() => {});
                lastNumAnim.start(() => {});
              } else {
                console.error(firstNumAnim.error, secondNumAnim.error);
              }
            }
          },
        });
    }
  };

  const hideAbout = () => {
    const who = document.getElementById("who");

    if (who) {
      const heroTitle = who.querySelector(".c-hero__title");
      const heroSmallTitle = who.querySelector(".c-hero__small-title");
      const heroScrollDown = who.querySelector(".c-hero__scroll-down path");

      anime({
        targets: heroTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroSmallTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });
    }
  };

  const revealAbout = () => {
    const who = document.getElementById("who");

    if (who) {
      const heroTitle = who.querySelector(".c-hero__title");
      const heroSmallTitle = who.querySelector(".c-hero__small-title");
      const heroScrollDown = who.querySelector(".c-hero__scroll-down path");

      const whoTl = anime.timeline();

      whoTl
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
        })
        .add({
          targets: heroSmallTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
          complete: () => {
            revealNav();
          },
        });
    }
  };

  const hideCase = () => {
    const casePage = document.getElementById("case");

    if (casePage) {
      const heroTitle = casePage.querySelector(".c-hero__title");
      const heroSmallTitle = casePage.querySelector(".c-hero__small-title");
      const heroScrollDown = casePage.querySelector(
        ".c-hero__scroll-down path"
      );

      anime({
        targets: heroTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroSmallTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });
    }
  };

  const revealCase = () => {
    const casePage = document.getElementById("case");

    if (casePage) {
      const heroTitle = casePage.querySelector(".c-hero__title");
      const heroSmallTitle = casePage.querySelector(".c-hero__small-title");
      const heroScrollDown = casePage.querySelector(
        ".c-hero__scroll-down path"
      );

      const caseTl = anime.timeline();

      caseTl
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
        })
        .add({
          targets: heroSmallTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
          complete: () => {
            revealNav();
          },
        });
    }
  };

  const hideListCases = () => {
    const caseList = document.getElementById("case-list");

    if (caseList) {
      const heroTitle = caseList.querySelector(".c-hero__title");
      const heroSmallTitle = caseList.querySelector(".c-hero__small-title");
      const heroScrollDown = caseList.querySelector(
        ".c-hero__scroll-down path"
      );

      anime({
        targets: heroTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroSmallTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });
    }
  };

  const revealListCases = () => {
    const caseList = document.getElementById("case-list");

    if (caseList) {
      const heroTitle = caseList.querySelector(".c-hero__title");
      const heroSmallTitle = caseList.querySelector(".c-hero__small-title");
      const heroScrollDown = caseList.querySelector(
        ".c-hero__scroll-down path"
      );

      const caseTl = anime.timeline();

      caseTl
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
        })
        .add({
          targets: heroSmallTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
          complete: () => {
            revealNav();
          },
        });
    }
  };

  const hideContacts = () => {
    const contacts = document.getElementById("contacts");

    if (contacts) {
      const heroImage = contacts.querySelector(".c-hero__image");
      const pin = contacts.querySelector(".c-contacts__pin");
      const heroScrollDown = contacts.querySelector(
        ".c-hero__scroll-down path"
      );
      const heroTitle = contacts.querySelector(".c-contacts__hero-title");
      const heroText = contacts.querySelector(".c-contacts__hero-text");
      const heroSubtitle = contacts.querySelector(".c-contacts__hero-subtitle");

      anime({
        targets: heroImage,
        opacity: 0,
        duration: 0,
      });

      anime({
        targets: pin,
        opacity: 0,
        translateY: "-10px",
        duration: 0,
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });

      anime({
        targets: heroTitle,
        opacity: 0,
        translateY: "-10px",
        duration: 0,
      });

      anime({
        targets: heroText,
        opacity: 0,
        translateY: "-10px",
        duration: 0,
      });

      anime({
        targets: heroSubtitle,
        opacity: 0,
        translateY: "-10px",
        duration: 0,
      });
    }
  };

  const revealContacts = () => {
    const contacts = document.getElementById("contacts");

    if (contacts) {
      const heroImage = contacts.querySelector(".c-hero__image");
      const pin = contacts.querySelector(".c-contacts__pin");
      const heroScrollDown = contacts.querySelector(
        ".c-hero__scroll-down path"
      );
      const heroTitle = contacts.querySelector(".c-contacts__hero-title");
      const heroText = contacts.querySelectorAll(".c-contacts__hero-text");
      const heroSubtitle = contacts.querySelector(".c-contacts__hero-subtitle");

      const contactsTl = anime.timeline();

      contactsTl
        .add({
          targets: heroImage,
          opacity: {
            value: 1,
            easing: "linear",
          },
          duration: 450,
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
        })
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=350",
        })
        .add({
          targets: heroSubtitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=350",
        })
        .add({
          targets: heroText,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=350",
        })
        .add({
          targets: pin,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=350",
          complete: () => {
            revealNav();
          },
        });
    }
  };

  const hideProduct = () => {
    const product = document.getElementById("prodotto");

    if (product) {
      const heroTitle = product.querySelector(".c-hero__title");
      const heroSmallTitle = product.querySelector(".c-hero__small-title");
      const heroScrollDown = product.querySelector(".c-hero__scroll-down path");

      anime({
        targets: heroTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroSmallTitle,
        opacity: 0,
        translateY: "-12px",
      });

      anime({
        targets: heroScrollDown,
        strokeDashoffset: anime.setDashoffset,
        duration: 0,
      });
    }
  };

  const revealProduct = () => {
    const product = document.getElementById("prodotto");
    if (product) {
      const heroTitle = product.querySelector(".c-hero__title");
      const heroSmallTitle = product.querySelector(".c-hero__small-title");
      const heroScrollDown = product.querySelector(".c-hero__scroll-down path");

      const caseTl = anime.timeline();

      caseTl
        .add({
          targets: heroTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
        })
        .add({
          targets: heroSmallTitle,
          opacity: {
            value: 1,
            easing: "linear",
          },
          translateY: {
            value: "0%",
            easing: [0.694, 0.048, 0.335, 1.0],
          },
          duration: 500,
          offset: "-=300",
        })
        .add({
          targets: heroScrollDown,
          strokeDashoffset: 0,
          easing: [0.694, 0.048, 0.335, 1.0],
          duration: 800,
          offset: "-=300",
          complete: () => {
            revealNav();
          },
        });
    }
  };
  const revealLanding = () => {
    const landing = document.getElementById("page-landing");

    if (landing) {
      revealNav();
    }
  };

  const hidePage = () => {
    hideNav();
    hideHome();
    hideAbout();
    hideCase();
    hideListCases();
    hideContacts();
    hideProduct();
  };

  const revealPage = () => {
    revealHome();
    revealAbout();
    revealCase();
    revealListCases();
    revealContacts();
    revealProduct();
    revealLanding();
  };

  const loadAnimation = () => {
    const loader = $1(".js-loader");

    const loadTl = anime.timeline();

    loadTl.add({
      targets: loader,
      opacity: 0,
      duration: 800,
      easing: "linear",
      complete: () => {
        loader.parentNode.removeChild(loader);

        revealPage();
      },
    });
  };

  const manageVideo = () => {
    const home = document.getElementById("home");
    const videolanding = document.getElementById("video-landing");

    if (home || videolanding) {
      if (window.matchMedia("(min-width: 1024px)").matches) {
        const videoHidden = $1(".js-video-hidden");
        const heroVideo = $1(".js-hero-video");
        const poster = videoHidden.dataset.poster;
        const mp4 = videoHidden.dataset.mp4;
        const webm = videoHidden.dataset.webm;

        const video = document.createElement("video");

        if (video.canPlayType("video/mp4").length > 0) {
          video.src = mp4;
        } else {
          video.src = webm;
        }

        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.poster = poster;
        video.style.backgroundImage = `url(${poster})`;
        video.className = "c-hero__video-bg";

        heroVideo.appendChild(video);
      } else {
        const createdVideo = $1(".c-hero__video-bg");
        const videoHidden = $1(".js-video-hidden");
        const bgMobile = videoHidden.dataset.bgMobile;
        const heroMobile = $1(".c-hero__mobile-image");

        console.log(heroMobile);

        heroMobile.style.backgroundImage = `url(${bgMobile})`;
        if (createdVideo) {
          createdVideo.parentNode.removeChild(createdVideo);
        }
      }
    }
  };

  const tooltipManagement = () => {
    const ref = $(".js-active-tooltip");

    if (ref) {
      tippy(ref, {
        placement: "bottom",
        html: "#template",
        maxWidth: "600px",
        offset: "140, 40",
        arrow: true,
        arrowType: "large",
        theme: "moving",
      });
    }
  };

  const init = () => {
    initHomeActiveAnim();
    manageVideo();
    tooltipManagement();
  };

  return {
    init,
    initLoad: loadAnimation,
    hidePage,
    manageVideo,
    enterTransition,
    exitTransition,
  };
})();

export default AnimationManager;
